export default Object.freeze({
  ExecutiveSummary: 1,
  Location: 2,
  supervisionQualityEthicalSection: 3,
  FinancialResourcesBilling: 4,
  PublicOfficialsSection: 5,
  ServicesToOffer: 6,
  GeographicAreas: 7,
});
